module.exports = __webpack_public_path__ + "img/yuyintitle.a967c18f.png";